package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Finance_transaction(
  public val id: String,
  public val date: String,
  public val account_id: String,
  public val to_account_id: String?,
  public val cat_id: String?,
  public val type: String,
  public val amount: Long,
  public val description: String?,
  public val fund_id: String?,
  public val verdict: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
